import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Form, Spinner, Dropdown, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { MoneyRecive, MoneySend, More, Trash, User } from 'iconsax-react';
import MyApiClient from "../../../../../api-client/MyApiClient";
import { useProfile } from "../../../../../hooks/useProfile";
import { useNavigate } from "react-router-dom";

import { conMotivo } from "../../../../components/Util/erroreServer";
// Pagina Prenotazioni impianti
const FacilitiesCalendar = () => {
  const navigate = useNavigate();
  const { profile, loading: profileLoading } = useProfile();
  const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';
  const [date, setDate] = useState(() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  });
  const [venues, setVenues] = useState([]);
  const [venuesInfoById, setVenuesInfoById] = useState({});
  const [selectedVenueId, setSelectedVenueId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingVenues, setLoadingVenues] = useState(false);
  const controlHeight = '32px';

  // Stati per azioni e modali (coerenti con calendario lezioni)
  const [confirmShowed, setConfirmShowed] = useState(false);
  const [confirmPaymentShowed, setConfirmPaymentShowed] = useState(false);
  const [onContinue, setOnContinue] = useState(null);
  const [confirmText, setConfirmText] = useState('');

  const [modalShowed, setModalShowed] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const [loadingShowed, setLoadingShowed] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [bookingPlayerModal, setBookingPlayerModal] = useState(false);
  const [pendingBookingSlot, setPendingBookingSlot] = useState(null);
  const [selectedBookingPlayer, setSelectedBookingPlayer] = useState(null);

  const loadBookingPlayerOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) return [];
    try {
      const tokenDetailsString = sessionStorage.getItem('userDetails');
      if (tokenDetailsString) {
        const tokenDetails = JSON.parse(tokenDetailsString);
        const api = new MyApiClient();
        const playersData = await api.getProfilesByFilters(tokenDetails.idToken, 10000, inputValue, 'IDS_PLAY');
        if (playersData && !playersData.error) {
          return playersData.items.map(el => ({ value: el.userId, label: el.name }));
        }
      }
    } catch (e) {
      console.error(e);
    }
    return [];
  };

  const openBookingModal = (row) => {
    setPendingBookingSlot(row);
    setSelectedBookingPlayer(null);
    setBookingPlayerModal(true);
  };

  const confirmBooking = () => {
    if (!selectedBookingPlayer || !pendingBookingSlot) return;
    const row = pendingBookingSlot;
    const sportType = (venuesInfoById[row.venueId] || {}).sportType || '';
    const url = `/struttura/booking/userFacilities?date=${encodeURIComponent(date)}&sportType=${encodeURIComponent(sportType)}&venueId=${encodeURIComponent(row.venueId)}&startTime=${encodeURIComponent(row.startTime)}&endTime=${encodeURIComponent(row.endTime)}&playerId=${encodeURIComponent(selectedBookingPlayer.value)}&playerName=${encodeURIComponent(selectedBookingPlayer.label)}`;
    navigate(url);
  };

  const optionsPayment = [
    { value: "CASH", label: "Contanti" },
    { value: "CARD", label: "Carta di credito" },
    { value: "BANK_TRANSFER", label: "Bonifico" }
  ];
  const [modalita_pagamento, setModalita_pagamento] = useState('');
  const [skip_generate_document, setSkipGenerateDocument] = useState(false);

  useEffect(() => {
    if (!profileLoading && profile && !isFatturazioneConfirmed && skip_generate_document !== true) {
      setSkipGenerateDocument(true);
    }
  }, [profileLoading, profile, isFatturazioneConfirmed, skip_generate_document]);
  const [selectedSlot, setSelectedSlot] = useState('');
  const handleSelectChange = (selectedOption, name) => {
    if (name === 'modalita_pagamento') {
      setModalita_pagamento(selectedOption.value);
    } else if (name === 'skip_generate_document') {
      setSkipGenerateDocument(selectedOption.value);
    }
  };

  const token = useMemo(() => {
    try {
      const s = sessionStorage.getItem("userDetails");
      if (s) {
        const obj = JSON.parse(s);
        return obj.idToken;
      }
    } catch (e) {}
    return null;
  }, []);

  // Carica lista impianti della struttura
  useEffect(() => {
    const loadVenues = async () => {
      if (!token) return;
      try {
        setLoadingVenues(true);
        const api = new MyApiClient();
        const res = await api.getVenues(token);
        if (res && Array.isArray(res)) {
          const options = res.map(v => ({ value: v.id || v.venueId || v.idVenue, label: v.name || v.venueName || v.description }));
          setVenues(options);
          const map = {};
          res.forEach(v => {
            const id = v.id || v.venueId || v.idVenue;
            map[id] = {
              sportType: v.sportType,
              name: v.name || v.venueName || v.description
            };
          });
          setVenuesInfoById(map);
        }
      } catch (err) {
        console.error("Errore caricamento impianti", err);
      } finally {
        setLoadingVenues(false);
      }
    };
    loadVenues();
  }, [token]);

  // Carica calendario per data e impianto selezionato
  const fetchCalendar = async () => {
    if (!token || !date) return;
    try {
      setLoading(true);
      const api = new MyApiClient();
      const res = await api.getVenuesCalendar(token, date, selectedVenueId || null);
      if (Array.isArray(res)) {
        setData(res);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Errore lettura calendario impianti", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCalendar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, selectedVenueId, token]);

  const slotOptions = useMemo(() => {
    const set = new Set();
    (data || []).forEach(v => {
      const venueMatch = !selectedVenueId || String(v.venueId) === String(selectedVenueId);
      if (venueMatch) {
        (v.availableSlots || []).forEach(s => {
          set.add(`${s.startTime} - ${s.endTime}`);
        });
      }
    });
    const arr = Array.from(set);
    arr.sort((a, b) => a.split(' - ')[0].localeCompare(b.split(' - ')[0]));
    return arr.map(str => ({ value: str, label: str }));
  }, [data, selectedVenueId]);

  useEffect(() => {
    setSelectedSlot('');
  }, [date, selectedVenueId]);

  const rows = useMemo(() => {
    const dayLabel = () => {
      try {
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
      } catch {
        return date;
      }
    };
    const list = [];
    (data || []).forEach(v => {
      (v.availableSlots || []).forEach(s => {
        list.push({
          venueName: v.venueName,
          venueId: v.venueId,
          day: dayLabel(),
          slot: `${s.startTime} - ${s.endTime}`,
          startTime: s.startTime,
          endTime: s.endTime,
          isAvailable: !!s.isAvailable,
          notes: s.notes ? s.notes.replace(/^Prenotazione impianto\s*/i, '').trim() || "-" : "-",
          bookingUserVenueId: s.bookingUserVenueId || null,
          status: s.status
        });
      });
    });
    const filtered = selectedSlot ? list.filter(r => (`${r.startTime} - ${r.endTime}`) === selectedSlot) : list;
    filtered.sort((a, b) => {
      const byVenue = (a.venueName || "").localeCompare(b.venueName || "");
      if (byVenue !== 0) return byVenue;
      const byDay = (a.day || "").localeCompare(b.day || "");
      if (byDay !== 0) return byDay;
      return (a.startTime || "").localeCompare(b.startTime || "");
    });
    return filtered;
  }, [data, date, selectedSlot]);

  // Risolve l'id della prenotazione utente per uno slot specifico
  const resolveUserVenueId = async (row) => {
    if (row.bookingUserVenueId) return row.bookingUserVenueId;
    try {
      const api = new MyApiClient();
      const list = await api.getUserBookingVenues(token, row.venueId);
      if (Array.isArray(list)) {
        const found = list.find(el => (
          el.bookingDate === date &&
          el.startTime === row.startTime &&
          el.endTime === row.endTime
        ));
        return found ? found.id : null;
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  // Azioni: Visualizza
  const openDetail = async (row) => {
    setLoadingShowed(true);
    const userVenueId = await resolveUserVenueId(row);
    setLoadingShowed(false);
    if (userVenueId) {
      navigate('/struttura/booking/uservenues/' + userVenueId);
    } else {
      setModalTitle("Errore durante l'operazione");
      setModalText("Impossibile aprire il dettaglio: prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
    }
  };

  // Azioni: Annulla
  const deleteDetail = (row) => {
    setOnContinue(() => () => continueDelete(row));
    setConfirmShowed(true);
    setConfirmText("Sei sicuro di volere continuare? La prenotazione sarà annullata.");
  };

  const continueDelete = async (row) => {
    setConfirmShowed(false);
    setLoadingShowed(true);
    const userVenueId = await resolveUserVenueId(row);
    if (!userVenueId) {
      setLoadingShowed(false);
      setModalTitle("Errore durante l'operazione");
      setModalText("Prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
      return;
    }
    try {
      const api = new MyApiClient();
      const resp = await api.setCancelledUserVenue(token, userVenueId, '');
      setLoadingShowed(false);
      if (!resp || resp.error) {
        setModalTitle("Errore durante l'operazione");
        setModalText(conMotivo("Si è verificato un errore durante l'annullamento."));
        setModalShowed(true);
      } else {
        fetchCalendar();
      }
    } catch (error) {
      setLoadingShowed(false);
      console.error(error);
      setModalTitle("Errore durante l'operazione");
      setModalText(conMotivo("Si è verificato un errore durante l'annullamento."));
      setModalShowed(true);
    }
  };

  // Azioni: Pagamento
  const paymentDetail = (row) => {
    setSelectedRow(row);
    setConfirmPaymentShowed(true);
  };

  const continuePayment = async (row, selectedPagamento) => {
    setConfirmPaymentShowed(false);
    setLoadingShowed(true);
    const userVenueId = await resolveUserVenueId(row);
    if (!userVenueId) {
      setLoadingShowed(false);
      setModalTitle("Errore durante l'operazione");
      setModalText("Prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
      return;
    }
    try {
      const api = new MyApiClient();
      const resp = await api.setPayedUserVenue(token, userVenueId, selectedPagamento, skip_generate_document);
      setLoadingShowed(false);
      if (!resp || resp.error) {
        setModalTitle("Errore durante l'operazione");
        setModalText(conMotivo("Si è verificato un errore durante la registrazione del pagamento."));
        setModalShowed(true);
      } else {
        fetchCalendar();
      }
    } catch (error) {
      setLoadingShowed(false);
      console.error(error);
      setModalTitle("Errore durante l'operazione");
      setModalText(conMotivo("Si è verificato un errore durante la registrazione del pagamento."));
      setModalShowed(true);
    }
  };

  // Azioni: Rimborso
  const refundDetail = (row) => {
    setOnContinue(() => () => continueRefund(row));
    setConfirmShowed(true);
    setConfirmText("Sei sicuro di volere continuare? La prenotazione sarà impostata come rimborsata. Nessun documento verrà emesso.");
  };

  const continueRefund = async (row) => {
    setConfirmShowed(false);
    setLoadingShowed(true);
    const userVenueId = await resolveUserVenueId(row);
    if (!userVenueId) {
      setLoadingShowed(false);
      setModalTitle("Errore durante l'operazione");
      setModalText("Prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
      return;
    }
    try {
      const api = new MyApiClient();
      const resp = await api.setRefundedUserVenue(token, userVenueId, '');
      setLoadingShowed(false);
      if (!resp || resp.error) {
        setModalTitle("Errore durante l'operazione");
        setModalText(conMotivo("Si è verificato un errore durante l'impostazione a rimborsato."));
        setModalShowed(true);
      } else {
        fetchCalendar();
      }
    } catch (error) {
      setLoadingShowed(false);
      console.error(error);
      setModalTitle("Errore durante l'operazione");
      setModalText(conMotivo("Si è verificato un errore durante l'impostazione a rimborsato."));
      setModalShowed(true);
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-body sid-card-body--spaced">
          {/* Modale caricamento operazioni */}
          <Modal className="fade" show={loadingShowed} centered>
            <Modal.Body className="text-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
              <div>Caricamento in corso...</div>
            </Modal.Body>
          </Modal>

          {/* Modale messaggi */}
          <Modal className="fade" show={modalShowed} centered>
            <Modal.Header>
              <Modal.Title>{modalTitle}</Modal.Title>
              <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
              </Button>
            </Modal.Header>
            <Modal.Body>
              <Row><Col className="col-xl-64">{modalText}</Col></Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
              <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                Chiudi
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modale conferma generica (annulla/rimborsa) */}
          <Modal className="fade" show={confirmShowed} centered>
            <Modal.Header>
              <Modal.Title>Sei sicuro?</Modal.Title>
              <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
              </Button>
            </Modal.Header>
            <Modal.Body>
              <Row><Col className="col-xl-64" dangerouslySetInnerHTML={{ __html: confirmText }}></Col></Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
              <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                Chiudi
              </Button>
              <Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                Continua
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modale conferma pagamento */}
          <Modal className="fade" show={confirmPaymentShowed} centered>
            <Modal.Header>
              <Modal.Title>Sei sicuro?</Modal.Title>
              <Button onClick={() => setConfirmPaymentShowed(false)} variant="" className="btn-close">
              </Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col className="col-xl-64">
                  Sei sicuro di volere continuare? La prenotazione sarà impostata come pagata. <b>Attenzione!</b> Procedendo il corrispondente documento fiscale verrà emesso e inviato se abilitato per la tua struttura.
                </Col>
              </Row>
              <Row className="mt-4">
                <Col className="col-xl-64">
                  <Form.Label>Modalità di pagamento</Form.Label>
                  <Select
                    className="mt-2"
                    name="modalita_pagamento"
                    placeholder="Seleziona la modalità di pagamento"
                    value={optionsPayment.find(option => option.value === modalita_pagamento) || null}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")}
                    options={optionsPayment}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col className="col-xl-64">
                  <Form.Label>Genera documento</Form.Label>
                  <Select
                    isDisabled={!isFatturazioneConfirmed}
                    className="mt-2"
                    name="skip_generate_document"
                    placeholder="Seleziona"
                    value={[{value: false, label: 'Si'}, {value: true, label: 'No'}].find(option => option.value === skip_generate_document) || null}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "skip_generate_document")}
                    options={[{value: false, label: 'Si'}, {value: true, label: 'No'}]}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
              <Button className="btn btn-light btn-add" onClick={() => setConfirmPaymentShowed(false)}>
                Chiudi
              </Button>
              <Button
                className="btn btn-primary btn-add"
                onClick={() => {
                  if (!modalita_pagamento) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Devi selezionare una modalità di pagamento per procedere.");
                    setModalShowed(true);
                    return;
                  }
                  setConfirmPaymentShowed(false);
                  continuePayment(selectedRow, modalita_pagamento);
                }}
              >
                Continua
              </Button>
            </Modal.Footer>
          </Modal>
          <Row className="mb-3 justify-content-start">
            {!loadingVenues && venues.length > 0 && (
              <Col xs="auto" className="mb-2">
                <Form.Label>Impianto</Form.Label>
                <Form.Select
                  value={selectedVenueId}
                  onChange={(e) => setSelectedVenueId(e.target.value)}
                  size="sm"
                  style={{ minWidth: 180, height: controlHeight }}
                >
                  <option value="">Tutti</option>
                  {venues.map(v => (
                    <option key={v.value} value={v.value}>{v.label}</option>
                  ))}
                </Form.Select>
              </Col>
            )}
            <Col xs="auto" className="mb-2">
              <Form.Label>Data</Form.Label>
              <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} size="sm" style={{ minWidth: 160, height: controlHeight }} />
            </Col>
            <Col xs="auto" className="mb-2">
              <Form.Label>Slot</Form.Label>
              <Form.Select
                value={selectedSlot}
                onChange={(e) => setSelectedSlot(e.target.value)}
                size="sm"
                style={{ minWidth: 160, height: controlHeight }}
              >
                <option value="">Tutti</option>
                {slotOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </Form.Select>
            </Col>
            <Col xs="auto" className="d-flex align-items-end mb-2">
              <button className="btn btn-primary btn-sm d-inline-flex align-items-center" onClick={fetchCalendar} disabled={loading} style={{ height: controlHeight }}>
                {loading ? <Spinner size="sm" animation="border" className="me-2" /> : null}
                Cerca
              </button>
            </Col>
          </Row>

          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Impianto</th>
                  <th>Giorno</th>
                  <th>Slot</th>
                  <th>Stato</th>
                  <th>Dettagli</th>
                  <th>Pagamento</th>
                  <th>Azione</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <Spinner animation="border" />
                    </td>
                  </tr>
                )}
                {!loading && rows.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      Nessun dato disponibile
                    </td>
                  </tr>
                )}
                {!loading && rows.map((row, idx) => {
                  const prev = rows[idx - 1];
                  const sameGroup = prev && prev.venueName === row.venueName && prev.day === row.day;
                  const venueCell = sameGroup ? "" : row.venueName;
                  const dayCell = sameGroup ? "" : row.day;
                  return (
                  <tr key={`${row.venueId}-${idx}`}>
                    <td>{venueCell}</td>
                    <td>{dayCell}</td>
                    <td>{row.slot}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${row.isAvailable ? 'text-success' : 'text-danger'}`}></i>
                        <span className="text-dark">{row.isAvailable ? 'Disponibile' : 'Prenotato'}</span>
                      </div>
                    </td>
                    <td>{row.notes}</td>
                    <td>
                      {!row.isAvailable ? (
                        <div className="d-flex align-items-center">
                          <i className={`fa fa-circle me-1 ${row.status === 'PAID' ? 'text-success' : 'text-danger'}`}></i>
                          <span className="text-dark">{row.status === 'PAID' ? 'Pagato' : 'Non pagato'}</span>
                        </div>
                      ) : null}
                    </td>
                    <td>
                      <Dropdown drop="auto">
                        <Dropdown.Toggle className="btn-primary light sharp i-false btn-action">
                          <More />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {row.isAvailable ? (
                            <Dropdown.Item onClick={() => openBookingModal(row)}>
                              <span className="me-2"><User size="20" /></span> Prenota
                            </Dropdown.Item>
                          ) : (
                            <>
                              <Dropdown.Item onClick={() => openDetail(row)}><span className="me-2"><User size="20" /></span> Visualizza</Dropdown.Item>
                              {row.status === 'UNPAID' && <Dropdown.Item onClick={() => paymentDetail(row)} className="text-danger"><span className="me-2"><MoneyRecive size="20"/></span>Registra pagamento</Dropdown.Item> }
                              {row.status === 'UNPAID' && <Dropdown.Item onClick={() => deleteDetail(row)} className="text-danger"><span className="me-2"><Trash size="20"/></span>Annulla</Dropdown.Item> }
                              {row.status === 'PAID' && <Dropdown.Item onClick={() => refundDetail(row)} className="text-danger"><span className="me-2"><MoneySend size="20"/></span>Rimborsa</Dropdown.Item> }
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                )})}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Modal className="fade" show={bookingPlayerModal} centered onHide={() => setBookingPlayerModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Seleziona player</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pendingBookingSlot && (
            <p className="text-muted mb-3">
              Slot: <strong>{pendingBookingSlot.startTime} – {pendingBookingSlot.endTime}</strong>
            </p>
          )}
          <AsyncSelect
            value={selectedBookingPlayer}
            onChange={setSelectedBookingPlayer}
            loadOptions={loadBookingPlayerOptions}
            placeholder="Digita almeno 3 caratteri..."
            noOptionsMessage={({ inputValue }) =>
              inputValue.length < 3 ? "Digita almeno 3 caratteri" : "Nessun utente trovato"
            }
            loadingMessage={() => "Ricerca in corso..."}
            isClearable
            cacheOptions
            defaultOptions={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBookingPlayerModal(false)}>Annulla</Button>
          <Button variant="primary" onClick={confirmBooking} disabled={!selectedBookingPlayer}>Conferma</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FacilitiesCalendar;